/** Patron tier shaping — mirrors backend /spots list rules for smooth UX on all islands. */

export const BASIC_SPOT_LIMIT = 6;
export const PRO_SPOT_LIMIT = 50;
export const BASIC_RECOMMENDATION_LOCK_FROM = 2;

export function isPatronPro(user) {
  return user?.tier === "pro" || user?.subscription_tier === "premium" || user?.is_pro === true;
}

export function applyTierToSpots(spots, { isPro = false, limitReached = false } = {}) {
  const list = Array.isArray(spots) ? [...spots] : [];
  if (!list.length) return [];

  if (isPro) {
    return list.slice(0, PRO_SPOT_LIMIT).map((spot) => ({
      ...spot,
      locked: false,
    }));
  }

  if (limitReached) {
    return list.slice(0, 3).map((spot, idx) => ({
      ...spot,
      locked: idx >= 1,
      description:
        idx >= 1
          ? `${(spot.short_description || spot.description || "").slice(0, 50)}...`
          : spot.description,
    }));
  }

  const capped = list.slice(0, BASIC_SPOT_LIMIT);
  return capped.map((spot, idx) => {
    const premium = Boolean(spot.is_premium_content);
    const lock = premium || idx >= BASIC_RECOMMENDATION_LOCK_FROM;
    if (!lock) return { ...spot, locked: false };

    const desc = spot.description || spot.short_description || "";
    return {
      ...spot,
      locked: true,
      is_premium_content: premium || idx >= BASIC_RECOMMENDATION_LOCK_FROM,
      description: premium
        ? `${desc.slice(0, 80)}... [PRO content]`
        : `${(spot.short_description || desc).slice(0, 50)}...`,
    };
  });
}

export function applyTierToRecommendations(recs, { isPro = false } = {}) {
  if (!recs?.spots) return recs;
  if (isPro) return recs;

  const spots = recs.spots.slice(0, 4).map((spot, idx) => {
    if (idx < BASIC_RECOMMENDATION_LOCK_FROM) return spot;
    return {
      ...spot,
      locked: true,
      description: `${(spot.short_description || spot.description || "").slice(0, 50)}...`,
    };
  });
  return { ...recs, spots };
}

export function filterAllInclusiveSpots(spots) {
  return (spots || []).filter(
    (spot) =>
      spot.all_inclusive === true ||
      (Array.isArray(spot.tags) && spot.tags.some((t) => String(t).toLowerCase().includes("all_inclusive")))
  );
}
